import { render, staticRenderFns } from "./AuthorAdmin.vue?vue&type=template&id=c906d470&"
import script from "./AuthorAdmin.vue?vue&type=script&lang=js&"
export * from "./AuthorAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports